import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { Payment } from './payment';
import { TransactionStatus } from './transaction-status';
import { TransactionType } from './transaction-type';

@inheritSerialization(AbstractModel)
export class Transaction extends AbstractModel {
  @autoserializeAs(TransactionType)
  transactionType: TransactionType;

  @autoserializeAs(Payment)
  payment: Payment;

  @autoserializeAs(TransactionStatus)
  transactionStatus: TransactionStatus;

  @autoserialize
  errorMessage: string;

  @autoserialize
  amount: number;

  @autoserialize
  processorName: string;

  @autoserialize
  authCode: string;

  @autoserialize
  processorTransactionId: string;

  @autoserialize
  settled: boolean;

  @autoserializeAs(Date)
  effectiveDate: Date;

  @autoserializeAs(Date)
  postingDate: Date;

  static OnSerialized(instance: Transaction, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.effectiveDate)) {
      json.effectiveDate = DateUtil.serializeDate(instance.effectiveDate);
    }

    if (!isNullOrUndefined(instance.postingDate)) {
      json.postingDate = DateUtil.serializeDate(instance.postingDate);
    }
  }

  static OnDeserialized(instance: Transaction, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['effectiveDate'])) {
      instance.effectiveDate = DateUtil.deserializeDate(json['effectiveDate']);
    }

    if (!isNullOrUndefined(json['postingDate'])) {
      instance.postingDate = DateUtil.deserializeDate(json['postingDate']);
    }
  }
}
